import "./ListDetailLocalSite.scss"
import Sidebar from "../../../components/sidebar/Sidebar"
import Navbar from "../../../components/navbar/Navbar"
import DataTableSiteLocal from "../../../components/datatableTicketSiteLocal/DatatableSiteLocal";

const ListDetailLocalSite = ({columns}) => {
  return (
    <div className="list">
      <Sidebar/>
      <div className="listContainer">
        <Navbar/>
        <DataTableSiteLocal columns={columns}/>
      </div>
    </div>
  )
}

export default ListDetailLocalSite